<template>
  <b-card>
    <b-row class="mb-1">
      <b-col class="text-right">
        <b-button
          v-b-modal.form-role-modal
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="cleanUpForm()"
        >
          Tambah
        </b-button>
      </b-col>
    </b-row>

    <BaseTable
      :fields="fields"
      :items="items"
      :loading="loading"
      :rows="pagination.total"
      :perPage="filter.size"
      :currentPage="filter.page"
      :handle-page-change="handlePageChange"
      :detail-item="detailItem"
      :edit-item="editItem"
      :delete-item="deleteItem"
      hide-delete
    />

    <FormRole
      :page-title="pageTitle"
      :loading="loading"
      :edit-id="editId"
      ref="formRoleRef"
      :create-item="createItem"
      :update-item="updateItem"
      :formPayload="formPayload"
      @formPayloadAnnouncement="getPayload($event)"
    />

    <DetailRole :page-title="pageTitle" :result="detail" />
  </b-card>
</template>

<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";

import { RoleService } from "@/services/role.service";

import {
  BCard,
  BRow,
  BCol,
  BButton,
  BFormInput,
  BSpinner,
} from "bootstrap-vue";
import { successNotification, errorNotification } from "@/auth/utils";
import vSelect from "vue-select";

import BaseTable from "@/components/BaseTable.vue";
import DetailRole from "@/components/Role/DetailRole.vue";
import BranchListComponent from "@/components/Base/BranchListComponent.vue";
import EmployeeListComponent from "@/components/Base/EmployeeListComponent.vue";
import FormRole from "../components/Role/FormRole.vue";

export default {
  name: "SppdPage",

  components: {
    BaseTable,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BSpinner,
    vSelect,
    DetailRole,
    BranchListComponent,
    EmployeeListComponent,
    FormRole,
  },

  directives: {
    Ripple,
  },

  watch: {
    "filter.page"() {
      this.fetchData();
    },
  },

  setup() {
    return {
      successNotification,
      errorNotification,
      BaseTable,
    };
  },

  data() {
    return {
      key: "role",
      pageTitle: "Role",
      items: [],
      detail: Object,
      error: false,
      loading: false,
      pagination: {
        total: 0,
      },
      filter: {
        branchId: "",
        employeeId: "",
        startDate: "",
        endDate: "",
        page: 1,
        size: 10,
        sortDirection: "DESC",
      },
      fields: [
        {
          key: "no",
          label: "No",
        },
        {
          key: "roleName",
          label: "Nama Role",
        },
        {
          key: "roleCode",
          label: "Kode Role",
        },
        {
          key: "actions",
          label: "Aksi",
        },
      ],
      editId: null,
      formPayload: Object,
      isLoadingEmployeeList: false,
      filterValue: null,
    };
  },

  methods: {
    cleanUpForm() {
      this.editId = null;
      this.formPayload = {
        roleId: "",
        roleCode: "",
        roleName: "",
        isAdmin: false,
        selectedUicomponents: [],
        isAdd: true
      };
      this.$refs.formRoleRef.fetchUicomponentData();
    },
    filterData() {
      this.fetchData();
    },
    async fetchData() {
      this.prepareFilter();
      this.loading = true;
      try {
        const { data } = await RoleService.findAll(this.filter);

        this.items = data.content;
        this.pagination.total = data.total;
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    detailItem(item) {
      this.detail = item;
      this.$bvModal.show("detail-" + this.key + "-modal");
    },
    editItem(item) {
      window.console.log(item);
      this.editId = item.roleId;
      this.formPayload = {
        roleCode: item.roleCode,
        roleName: item.roleName,
        roleId: item.roleId,
        isAdmin: item.isAdmin,
        uiComponents: item.uiComponents,
        isAdd: false
      };
      this.showFormModal();
    },
    async createItem() {
      this.loading = true;

      // let uiComponents = {
      //   roleName: this.formPayload.roleName,
      //   componentCode: this.formPayload.selectedUicomponents
      // }
      let req = {
        roleName: this.formPayload.roleName,
        roleCode: this.formPayload.roleCode,
        roleId: 0,
        isAdmin: this.formPayload.isAdmin,
        uiComponents: {
          componentCode: []
        }
      };
      this.formPayload.selectedUicomponents.forEach((items) => {
        req.uiComponents.componentCode.push(items.componentCode);
      });
      // this.formPayload.uiComponents = uiComponents
      // window.console.log(req);
      try {
        await RoleService.create(req);
        successNotification(
          this,
          "Success",
          `${this.pageTitle} berhasil dibuat!`
        );
        this.hideFormModal();
        this.fetchData();
      } catch (e) {
        this.error = e.message;
        errorNotification(this, "Oops!", e.message);
      } finally {
        this.loading = false;
      }
    },
    async updateItem() {
        // let uiComponents = {
        //     componentCode: this.formPayload.selectedUicomponents
        // }
        // this.formPayload.uiComponents = uiComponents

        // delete this.selectedUicomponents
        this.loading = true;
        let req = {
          isAdmin: this.formPayload.isAdmin,
          roleCode: this.formPayload.roleCode,
          roleId: 0,
          roleName: this.formPayload.roleName,
          uiComponents: {
            componentCode: []
          }
        };
        this.formPayload.selectedUicomponents.forEach((items) => {
          req.uiComponents.componentCode.push(items.componentCode);
        });
        window.console.log(req);
        window.console.log(this.editId);
        try {
          await RoleService.update(this.editId, req);
          successNotification(
            this,
            "Success",
            `${this.pageTitle} berhasil diubah!`
          );
          this.hideFormModal();
          this.fetchData();
          this.loading = false;
        } catch (e) {
          this.error = e.message;
          errorNotification(this, "Oops!", e.message);
          this.loading = false;
        } finally {
          this.loading = false;
        }
    },
    deleteItem(item) {
      this.$swal({
        title: "Anda yakin?",
        text: "Anda yakin ingin menghapus data ini?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await RoleService.delete(item.id);
            successNotification(
              this,
              "Success",
              `${this.pageTitle} berhasil dihapus!`
            );
            this.hideFormModal();
            this.fetchData();
          } catch (e) {
            this.error = e.message;
            errorNotification(this, "Oops!", e.message);
          } finally {
            this.loading = false;
          }
        }
      });
    },
    getPayload(value) {
      if (value) {
        this.formPayload = value;
      }
    },
    prepareFilter() {
      for (const key in this.filter) {
        if (this.filter.hasOwnProperty(key) && this.filter[key] != null) {
          if (this.filter[key] == null || this.filter[key] == "") {
            delete this.filter[key];
          }
        }
      }
      return this.filter;
    },
    preparePayload() {
      const form = new FormData();
      for (const key in this.formPayload) {
        if (
          this.formPayload.hasOwnProperty(key) &&
          this.formPayload[key] != null
        ) {
          form.append(key, this.formPayload[key]);
        }
      }

      return form;
    },
    showFormModal() {
      this.$bvModal.show(`form-${this.key}-modal`);
    },
    hideFormModal() {
      this.$bvModal.hide(`form-${this.key}-modal`);
    },
    handlePageChange(value) {
      this.loading = true;
      this.filter.page = value;
    },
  },

  created() {
    this.formPayload = {
      roleId: "",
      roleCode: "",
      roleName: "",
      isAdmin: false
    };
    this.fetchData();
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
